import { Modal, Typography } from 'antd'
import type { JSX } from 'react'

type ReuseDomainModalProps = {
  domain: string
  isOpen: boolean
  isSubmitting: boolean
  onCancel: () => void
  onConfirm: () => void
}

export function ReuseDomainModal({
  domain,
  isOpen,
  isSubmitting,
  onCancel,
  onConfirm,
}: ReuseDomainModalProps): JSX.Element {
  return (
    <Modal
      confirmLoading={isSubmitting}
      okText="Associate Domain"
      onCancel={onCancel}
      onOk={onConfirm}
      open={isOpen}
      title="Domain Already In Use"
    >
      <Typography.Paragraph>
        <Typography.Text strong>{domain}</Typography.Text> is already configured as a shared custom domain for another
        leader.
      </Typography.Paragraph>
      <Typography.Paragraph>
        Continuing will associate this leader with the existing shared domain and its current CloudFront setup — it will
        not create or independently verify a new domain. No further DNS or SSL steps are required.
      </Typography.Paragraph>
    </Modal>
  )
}
